export const palette = {
	brand: {
		DEFAULT: '#66d9ef',
		hover: '#52bcbf'
	},
	product: {
		DEFAULT: '#0BCF7D',
		hover: '#2BF29F',
		active: '#09a664'
	},
	community: {
		DEFAULT: '#9d6fff',
		hover: '#7f5ace'
	},
	newsletter: {
		DEFAULT: '#f35874',
		hover: '#d24e66'
	},
	documentation: {
		DEFAULT: '#fd971f',
		hover: '#da841e'
	},
	black: {
		DEFAULT: '#000000',
		100: '#F8F8F8',
		200: '#BAC0C7',
		400: '#868E96',
		500: '#5B6167',
		600: '#5B6167', // TODO: same as 500 in figma, ask ui/ux team
		800: '#313437',
		'800-20': '#31343733',
		850: '#1F1F1F',
		900: '#151515'
	},
	orange: {
		DEFAULT: '#FD971F'
	},
	purple: {
		DEFAULT: '#9747FF'
	},
	darkBackground: '#272822',
	darkBackground2: '#202020',
	brightBackground: '#2f302b',
	dividers: '#5b5b5b',
	dividerSecondary: '#2f302b',
	brightText: '#c0c0c0',
	grayText: '#868e96',
	customWhite: '#f8f8f8',
	disable: '#828181',
	selectBackground: '#2c2c2c',
	// TODO: Remove darkBlack and diagram colors after removing them from the code
	darkBlack: '#151515',
	diagram: '#313437',
	warning: '#FD971F',
	white: '#FFFFFF',
	error: {
		DEFAULT: '#D6031D',
		// TODO: UI/UX team need to provide the hover color for the error
		hover: '#8C001A'
	},
	input: {
		error: '#D6031D',
		filled: '#E6E6E5',
		disabled: '#5B6167'
	}
}
